import { createContext, ReactNode, useContext, useState } from "react";
import { IDecodedToken, tokenToUser } from "../services/userService";
import { isEqual } from 'lodash'

type AuthContextProps = {
  readonly user: IDecodedToken,
  setUser: (user: IDecodedToken) => void,
  hasUser: () => boolean,
  isAdm: () => boolean
}

const AuthContext = createContext<AuthContextProps>({
  user: {} as IDecodedToken,
  setUser: () => {},
  hasUser: () => false,
  isAdm: () => false
})

type AuthProviderProps = {
  children: ReactNode
}

export const AuthProvider = ({children}: AuthProviderProps) => {

  // Lê o token já no primeiro render: com o estado inicial vazio, hasUser()
  // era falso na montagem e o Router redirecionava qualquer rota interna
  // (reload/deep link) para /dashboard/app antes do useEffect rodar.
  const [user, setUser] = useState<IDecodedToken>(() => tokenToUser())

  return (
    <AuthContext.Provider value={{
      user,
      setUser,
      hasUser: () => !!user && !isEqual(user, {}),
      isAdm: () => (!!user && !isEqual(user, {}) && user.role === '1')
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)